/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class TopNavigation extends Component {
  @service
  session;

  @service
  store;

  @tracked
  peopleSelectorOpen = false;
  @tracked
  peopleSelectorClass = '';
  @tracked
  groupSelectorOpen = false;
  @tracked
  groupSelectorClass = '';
  @tracked
  students = [];
  @tracked
  groups = [];

  @action
  logout() {
    this.session.logout('topNavigation');
  }

  @action
  async switchSchool() {
    await this.session.switchSchool();
  }

  @action
  togglePeopleSelector() {
    var newClass = '';

    this.groupSelectorOpen = false;
    this.groupSelectorClass = '';

    this.toggleProperty('peopleSelectorOpen');
    newClass = this.peopleSelectorOpen ? 'active' : '';

    this.peopleSelectorClass = newClass;
  }

  @action
  toggleGroupSelector() {
    var newClass = '';

    this.peopleSelectorOpen = false;
    this.peopleSelectorClass = '';

    this.toggleProperty('groupSelectorOpen');
    newClass = this.groupSelectorOpen ? 'active' : '';

    this.groupSelectorClass = newClass;
  }

  init() {
    super.init(...arguments);
    this.students = this.store.peekAll('student');
    this.groups = this.store.peekAll('group');
  }
}
